import { GzLocalSandboxInstanceWebComponent } from './component/GzLocalSandboxInstanceWebComponent';

export { GzLocalSandboxInstanceWebComponent };
